import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AlphaNumericOnlyDirective } from './directives/alphanumeric-only.directive';
import { InputUpperCaseDirective } from './directives/input-uppercase';
import { NumberCurrencyFormatterDirective } from './directives/number-currency-formatter';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { InrFormatPipe } from './custompipes/inr-format.pipe';
import { CurrencyInputDirective } from './directives/currency-input.directive';
import { InrdisplayPipe } from './pipes/inrdisplay.pipe';
import { EllipsisPipe } from './pipes/ellipsis.pipe';
import { SafeUrlPipe } from './pipes/safeUrl.pipe';
import { ThrottleClickDirective } from './directives/throttle-click-directive ';
import { ElementFocus } from './directives/element-focus';
import { CpgcurrencyPipe } from './pipes/cpgcurrency.pipe';
import { PayexInfiniteScroll } from './directives/payex-infinite-scroll';
import { FullContentHeight } from './directives/full-content-height';
import { AppActionButton } from './directives/app-actionButton';
import { EmailMobilenoOnlyDirective } from './directives/email-mobileno-only.directive';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from '../_constants/translate-http-loader';
import { DateRangeSelectionComponent } from './date-range-selection/date-range-selection.component';
import { FullHeightElementDirective } from './directives/full-height-element.directive';
import { MonthSelectionComponent } from './month-selection/month-selection.component';
import { LibModule } from '../_libs/lib.module';
import { DateSelectionComponent } from './date-selection/date-selection.component';
import { DynamicDataTranslation } from './pipes/dynamicDataTranslationPipe';
import { TranslateWithDefault } from './pipes/translateWithDefault';
import { LocaleCurrencyDisplay } from './pipes/localeCurrencyDisplay.pipe';
import { SellerLogoImageDirective } from './directives/seller-logo-image';


const components = [
  AlphaNumericOnlyDirective,
  InputUpperCaseDirective,
  NumberCurrencyFormatterDirective,
  NumberOnlyDirective,
  InrFormatPipe,
  CurrencyInputDirective,
  EmailMobilenoOnlyDirective,
  InrdisplayPipe,
  EllipsisPipe,
  SafeUrlPipe,
  ThrottleClickDirective,
  ElementFocus,
  CpgcurrencyPipe,
  PayexInfiniteScroll,
  FullContentHeight,
  AppActionButton,
  DateRangeSelectionComponent,
  FullHeightElementDirective,
  MonthSelectionComponent,
  DateSelectionComponent,
  AppActionButton,
  DynamicDataTranslation,
  TranslateWithDefault,
  LocaleCurrencyDisplay,
  // EmailOnlyDirective,
  SellerLogoImageDirective
];

@NgModule({
  declarations: [components],
  imports: [
    CommonModule,
    FormsModule,
    LibModule
  ],
  exports: [
    components,
    TranslateModule
  ]
})
export class CoreModule { }
